<template>
    <div class="feedback">
        <div class="correct" v-if="correct && message">
            <i class="check circle icon"></i>
            <div class="message" v-html="message"></div>
        </div>
        <div class="incorrect" v-if="incorrect && message">
            <i class="times circle icon" ></i>
            <div class="message" v-html="message"></div>
        </div>
        <div class="neutral" v-if="!correct && !incorrect && message">
            <div class="message" v-html="message"></div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'FeedbackBox',
    props: ['message', 'correct', 'incorrect']
}
</script>
<style scoped>
.feedback .incorrect {
    color: #d9534f;
    background-color:mistyrose;
    display: flex;
}
.feedback .correct {
    color: #64b548;
    background-color:#def0d7;
    display: flex;
}
.feedback .neutral {
    color: #666666;
    background-color:#eee;
}
.feedback .incorrect, .feedback .correct, .feedback .neutral {
    padding: 15px;
}
i {
    font-size: 20px;
}
.message {
    margin-left: 15px;
}
</style>